import { useMemo } from 'react'
import { useGetProduct } from '@/hooks/use-block-and-pay'

export const useBoostingPackages = () => {
  const sevenDaysPackage = useGetProduct('seven-days-sponsored-listing-package')
  const fourteenDaysPackage = useGetProduct('fourteen-days-sponsored-listing-package')
  const thiryDaysPackage = useGetProduct('thirty-days-sponsored-listing-package')

  const packages = useMemo(() => {
    if (!sevenDaysPackage.data || !fourteenDaysPackage.data || !thiryDaysPackage.data) {
      return []
    }
    return [
      { ...sevenDaysPackage.data, duration: 7 },
      { ...fourteenDaysPackage.data, duration: 14, popular: true },
      { ...thiryDaysPackage.data, duration: 28 }
    ].map((pkg: any) => ({
      ...pkg.products[0],
      popular: pkg.popular,
      duration: pkg.duration,
      daily_price: (pkg.products[0].regular_plan_price / pkg.duration + Number.EPSILON).toFixed(2)
    }))
    // javascript can't express small decimals like 1.785 and internally use a number like 1.7849999999999998,
    // which truncates to '1.78'. Number.EPSILON is an infintesimal number that solves this problem and allow javascript to get over this issue
  }, [sevenDaysPackage.data, fourteenDaysPackage.data, thiryDaysPackage.data])
  return {
    packages,
    sevenDaysPackage,
    fourteenDaysPackage,
    thiryDaysPackage
  }
}
